import { render, staticRenderFns } from "./BaseProductConfigurationItem.vue?vue&type=template&id=77d50004&scoped=true"
import script from "./BaseProductConfigurationItem.vue?vue&type=script&lang=js"
export * from "./BaseProductConfigurationItem.vue?vue&type=script&lang=js"
import style0 from "./BaseProductConfigurationItem.vue?vue&type=style&index=0&id=77d50004&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d50004",
  null
  
)

export default component.exports